import {TypeHelper} from "../../../helpers/TypeHelper";
import {DocumentListViewToolbar} from "./DocumentListViewToolbar";
import {ListViewToolbarButton} from "./ListViewToolbarButton";
import React from "react";
import {useTranslation} from "react-i18next";

interface IProps {
    onCreateNewClick?: () => void;
    onCloneClick?: () => void;
    onEditClick?: () => void;
    onShowTransactionsPage?: () => void;
    children?: React.ReactNode;
    onDeleteClick?: () => void;
    onShowPopup?: () => void;
    onPostClick?: () => void;
    onCancelClick?: () => void;
    disabled?: boolean | undefined;
    handleCreateDocumentAction?: () => void;
    createDocumentActions?: any;
}

export const DocumentListViewDefaultToolbarButtons = ({
                                                          children,
                                                          onCancelClick,
                                                          onPostClick,
                                                          onDeleteClick,
                                                          onShowPopup,
                                                          onShowTransactionsPage,
                                                          onCreateNewClick,
                                                          onCloneClick,
                                                          createDocumentActions,
                                                          disabled,
                                                          handleCreateDocumentAction,
                                                          onEditClick
                                                      }: IProps) => {
    const {t} = useTranslation();
    const arrayChildren = React.Children.toArray(children);
    
    return (
        <>
            <ListViewToolbarButton caption={t("CreateNew")} onClick={onCreateNewClick} styleClass={"btn-primary"}
                                   extraClass={"me-2"} iconClass={"fa-solid fa-plus"}/>
            <div className={"flex-grow-1"}></div>
            <ListViewToolbarButton disabled={disabled} onClick={onShowPopup} extraClass={"me-2"}
                                   iconClass={"fa-solid fa-calendar"}/>
            <ListViewToolbarButton disabled={disabled} caption={t("Clone")} onClick={onCloneClick} extraClass={""}
                                   iconClass={"fa-solid fa-clone"}/>
            {arrayChildren &&
                arrayChildren.map((child: any, index) => {
                    return (
                        <React.Fragment key={index}>
                            {React.cloneElement(child, {
                                createDocumentActions: createDocumentActions,
                                handleCreateDocumentAction: handleCreateDocumentAction,
                                disabled: disabled
                            })}
                        </React.Fragment>
                    );
                })}
            <ListViewToolbarButton disabled={disabled} caption={t("Edit")} onClick={onEditClick}
                                   extraClass="me-2 ms-2" iconClass={"fa-solid fa-pen-to-square"}/>
            <ListViewToolbarButton disabled={disabled} caption={t("Delete")} onClick={onDeleteClick}
                                   extraClass="me-2" iconClass={"fa-solid fa-trash me-2"}/>
            <ListViewToolbarButton disabled={disabled} caption={t("Post")} onClick={onPostClick} extraClass="me-2"
                                   iconClass={"fa-solid fa-circle-check me-2"}/>
            <ListViewToolbarButton disabled={disabled} caption={t("Cancel")} onClick={onCancelClick}
                                   extraClass="me-2" iconClass={"fa-solid fa-ban me-2"}/>
            <ListViewToolbarButton disabled={disabled} caption={t("Transactions")} onClick={onShowTransactionsPage}
                                   iconClass={"fa-solid fa-list me-2"}/>
        </>
    );
};
